module.exports = __webpack_public_path__ + "static/media/STOGI REFERENCE TONEARM.ef5107b8.png";